module.exports = __webpack_public_path__ + "static/lost-connections-d51c34407073236e2332acfca86566a2.jpg";